//@ts-check
import { STORAGE_KEYS } from '@exchange-frontends/utils';

import { entitlementApiClient } from '../../utils/RequestClient';
import RequestSearchParams from '../../utils/RequestSearchParams';

/**
 * @param {import('@action-types/consent').PatchConsentParams} params
 * @returns {Promise<import('@action-types/consent').Consent>}
 * @throws {import('@action-types/RequestError').RequestError<import('@action-types/entitlement').EntitlementApiErrorResponse>}
 */
const patchConsent = async ({ token, orgId, appId, action, appType, stateToken, idToken, notes = 'N/A' }) => {
  const search = new RequestSearchParams({ appType, stateToken, idToken });
  const headers = new Headers({
    'x-org-id': orgId,
    authorization: token,
  });

  const storageStateToken = sessionStorage.getItem(STORAGE_KEYS.SP_ISV_STATE_TOKEN);
  if (storageStateToken) {
    headers.set('x-state-token', storageStateToken);
  }

  const storageNonce = sessionStorage.getItem(STORAGE_KEYS.SP_ISV_NONCE);
  if (storageNonce) {
    headers.set('x-nonce', storageNonce);
  }

  const { jsonResponse } = await entitlementApiClient.fetch({
    endpoint: `/enterprise/consent${search}`,
    requestOptions: {
      credentials: 'include',
      method: 'PATCH',
      body: JSON.stringify({ action, appId, notes }),
      headers,
    },
  });

  sessionStorage.removeItem(STORAGE_KEYS.SP_ISV_NONCE);
  sessionStorage.removeItem(STORAGE_KEYS.SP_ISV_STATE_TOKEN);

  return jsonResponse;
};

export default patchConsent;
